/**
 * * Configuração para o Componente de Select.
 */
export class SelectConfig {
    constructor(
        /**
         * * Texto do componente.
         */
        public label: string,
        /**
         * * Valor do input.
         */
        public value: string,
        /**
         * * Identificador do input.
         */
        public id?: string,
        /**
         * * Input Selecionado.
         */
        public selected?: boolean,
        /**
         * * Input Desabilitado.
         */
        public disabled?: boolean
    ) {}
}